import { Brain } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BrainIcon = createLucideIcon(Brain);
